/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["order-summary{display:block;margin:45px 0 35px;border-top:1px solid #e0e0e0;border-bottom:1px solid #e0e0e0}order-summary:empty{display:none}order-summary .line{display:flex;padding:15px 0;font-size:1.5rem}order-summary .line .summary-right{margin-left:auto}order-summary .emphasis{font-weight:500;border-top:1px solid #e0e0e0}"];
export { styles as styles };
